'use client';

import React from 'react';

import { Body, Display } from '@depop/web-thrift-ui/Typography';
import { Button } from '@depop/web-ui-kit/Button';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { Container } from '@/components/Container';
import { ExtendedLink } from '@/components/ExtendedLink';
import { YouTubeVideoIframe } from '@/components/YouTubeVideoIframe';
import { ausYoutubeVideoId, youtubeVideoId } from '@/constants/shippingLanding';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { SupportedLocation } from '@/modules/location/constants';
import { useSellNowHref } from '@/modules/signup/hooks/useSellNowHref';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  location: SupportedLocation;
};

export function YouTubeVideoSegment({ location }: Props) {
  const t = useTranslations('shipping');
  const [, currentUser] = useCurrentUser();
  const { href } = useSellNowHref();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  function handleCtaClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'depop_shipping_sell_cta',
      schemaVersion: '2.0',
    });
  }

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.videoContainer}>
          <YouTubeVideoIframe
            className={styles.youtubeVideo}
            videoId={
              location === SupportedLocation.AU
                ? ausYoutubeVideoId
                : youtubeVideoId
            }
          />
        </div>
        <span className={styles.textWrapper}>
          <Display>{t('ShippingPage.YouTubeSegment.Title')}</Display>
          <Body variant="md-regular">
            {t('ShippingPage.YouTubeSegment.Description')}
          </Body>
          <ExtendedLink
            href={href}
            className={styles.ctaWrapper}
            onClick={handleCtaClick}
          >
            <Button as="span">{t('ShippingPage.SellNowCTA')}</Button>
          </ExtendedLink>
        </span>
      </Container>
    </section>
  );
}
